var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasErrors
    ? _c(
        "BulmaMessage",
        {
          attrs: {
            value: _vm.hasErrors,
            closable: true,
            icon: _vm.iconName,
            iconColor: _vm.iconColor,
          },
          on: { close: _vm.exit },
          scopedSlots: _vm._u(
            [
              {
                key: "title",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.errorTitle) + " "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.length > 1,
                              expression: "errors.length > 1",
                            },
                          ],
                          staticClass: "ml-1",
                        },
                        [
                          _vm._v(
                            " (" +
                              _vm._s(_vm.index + 1) +
                              " of " +
                              _vm._s(_vm.errors.length) +
                              ") "
                          ),
                        ]
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "footer",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "level is-flex-grow-1 mt-0 mb-0" },
                      [
                        _c("div", { staticClass: "level-left" }, [
                          _vm.index > 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "button is-primary",
                                  on: {
                                    click: function ($event) {
                                      _vm.index--
                                    },
                                  },
                                },
                                [_vm._v(" Previous ")]
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.length > 1,
                                expression: "errors.length > 1",
                              },
                            ],
                            staticClass: "level-item has-text-centered",
                          },
                          [
                            _c("span", { staticClass: "tag" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.index + 1) +
                                  " / " +
                                  _vm._s(_vm.errors.length) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "level-right" }, [
                          _vm.index < _vm.errors.length - 1
                            ? _c(
                                "button",
                                {
                                  staticClass: "button is-primary",
                                  on: {
                                    click: function ($event) {
                                      _vm.index++
                                    },
                                  },
                                },
                                [_vm._v(" Next ")]
                              )
                            : _c(
                                "button",
                                {
                                  staticClass: "button is-primary",
                                  on: { click: _vm.exit },
                                },
                                [_vm._v(" Dismiss ")]
                              ),
                        ]),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            2698838605
          ),
        },
        [
          [
            _c("p", { staticClass: "my-4" }, [
              _c("span", { staticStyle: { "white-space": "pre-wrap" } }, [
                _vm._v(_vm._s(_vm.errors[_vm.index].message)),
              ]),
            ]),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "technical-details-toggle has-text-weight-light",
                  on: {
                    click: function ($event) {
                      _vm.showPanel = !_vm.showPanel
                    },
                  },
                },
                [
                  _c("span", [_vm._v("Technical Details")]),
                  _c(
                    "span",
                    {
                      staticClass: "msr msr-24px",
                      class: { "is-open": _vm.showPanel },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.showPanel
                              ? "keyboard_arrow_up"
                              : "keyboard_arrow_down"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showPanel,
                      expression: "showPanel",
                    },
                  ],
                  staticClass: "box mt-3 p-1",
                },
                [
                  _c("article", { staticClass: "message" }, [
                    _c(
                      "div",
                      {
                        staticClass: "message-body py-2 px-2",
                        staticStyle: {
                          border: "1px solid var(--bulma-border)",
                        },
                      },
                      [
                        _c(
                          "table",
                          { staticClass: "table is-fullwidth is-size-7" },
                          [
                            _c("tbody", [
                              _vm.errors[_vm.index].id > 0
                                ? _c("tr", [
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-justify-content-space-between is-align-items-center",
                                        },
                                        [
                                          _c("span", [_vm._v("Error ID:")]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.errors[_vm.index].id)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm.errors[_vm.index].statusCode
                                ? _c("tr", [
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-justify-content-space-between is-align-items-center",
                                        },
                                        [
                                          _c("span", [_vm._v("Status Code:")]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors[_vm.index].statusCode
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm.errors[_vm.index].timestamp
                                ? _c("tr", [
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-justify-content-space-between is-align-items-center",
                                        },
                                        [
                                          _c("span", [_vm._v("Timestamp:")]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$filters.formatDateTimeLocale(
                                                  _vm.errors[_vm.index]
                                                    .timestamp,
                                                  _vm.$userInfo.locale
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm.errors[_vm.index].statusCode &&
                              !_vm.showRaw &&
                              _vm.errors[_vm.index].url
                                ? _c("tr", [
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-justify-content-space-between is-align-items-center",
                                        },
                                        [
                                          _c("span", [_vm._v("Endpoint:")]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.errors[_vm.index].url)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }